import React from 'react'
import Disclaimer from 'components/LoanDetails/Disclaimer'
import SplitRate from './SplitRate'
import SingleRate from './SingleRate'

class Highlight extends React.Component {
  render() {
    const {
      loanApplication: {
        loanAmountLabel,
      },
      loanDetail: {
        interestType,
        settings: {
          repaymentYear,
        },
        calculator,
        calculator: {
          repaymentWithFrequency,
          principalAndInterestRepaymentWithFrequency,
        },
        summary: {
          hasInterestOnlyPeriod,
          fixedRepaymentTypeLabel,
          variableRepaymentTypeLabel,
          fixedRateLabel,
          fixedAmountLabel,
          variableAmountLabel,
          variableRateLabel,
        }
      },
    } = this.props;

    return(
      <div className='card card-border card-border-green mb-4'>
        <div className='card-body big'>
          <p>
            You are borrowing <strong>{ loanAmountLabel }</strong> over a <strong>{ repaymentYear} year</strong> term
          </p>
          {
            (interestType === 'split') ? (
              <SplitRate
                repaymentWithFrequency={ repaymentWithFrequency }
                fixedRateLabel={ fixedRateLabel }
                fixedAmountLabel={ fixedAmountLabel }
                fixedRepaymentTypeLabel={ fixedRepaymentTypeLabel }
                variableRepaymentTypeLabel={ variableRepaymentTypeLabel }
                variableRateLabel={ variableRateLabel }
                variableAmountLabel={ variableAmountLabel }
              />
            ) : (
              <SingleRate
                repaymentWithFrequency={ repaymentWithFrequency }
                interestType={ interestType }
                rateLabel={ calculator[interestType].displayableRateLabel }
              />
            )
          }
          {
            (hasInterestOnlyPeriod) && (
              <Disclaimer
                futureRepayment={ principalAndInterestRepaymentWithFrequency }
              />
            )
          }
        </div>
      </div>
    )
  }
}



export default Highlight
